// Testimonial Slider
$('.slider-testimonials').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplaySpeed: 2000,
  prevArrow: "<button type='button' class='slick-prev pull-left'><svg xmlns='http://www.w3.org/2000/svg' width='40px' height='40px' viewBox='0 0 24 24' fill='none'><rect width='24' height='24' fill='white'/><path d='M14.5 17L9.5 12L14.5 7' stroke='#000000' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
  nextArrow: "<button type='button' class='slick-next pull-right'><svg xmlns='http://www.w3.org/2000/svg' width='40px' height='40px' viewBox='0 0 24 24' fill='none'><rect width='24' height='24' fill='white'/><path d='M9.5 7L14.5 12L9.5 17' stroke='#000000' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

  $('.facets__filters ul#sidebar-menu li.menu-item a').click(function(event){
    $(this).parents('li.menu-item').addClass('is-active');
     $(this).parents('li.menu-item').siblings().removeClass('is-active');
  });


    $(document).ready(function() {
  $('.sub_category_filter h5.sidebar_title').click(function(){
      $('ul#sidebar-menu').toggleClass('active');
  });
});